<template>
  <v-dialog
    :value="dialog"
    persistent
    max-width="560"
    @click:outside="onClose"
  >
    <v-card class="parchment-bulk-success-dialog">
      <v-toolbar class="parchment-bulk-success-dialog__toolbar" flat dark>
        <v-toolbar-title class="white--text font-weight-bold">
          {{ $t("memberDataSection.parchmentDelivery.bulkImport.importSuccessDialogTitle") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="parchment-bulk-success-dialog__body py-8 px-6 text-center">
        <div class="parchment-bulk-success-dialog__icon-wrap mx-auto mb-5">
          <v-icon class="parchment-bulk-success-dialog__icon" size="44">mdi-check</v-icon>
        </div>
        <p class="parchment-bulk-success-dialog__message mb-0 black--text">
          {{
            $t("memberDataSection.parchmentDelivery.bulkImport.importSuccessDialogMessage", {
              count: recordCount,
            })
          }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ParchmentDeliveryBulkImportSuccessDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    recordCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.parchment-bulk-success-dialog__toolbar {
  background-color: #1b5e20 !important;
}

.parchment-bulk-success-dialog__body {
  font-family: Poppins, sans-serif;
}

.parchment-bulk-success-dialog__icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.parchment-bulk-success-dialog__icon {
  color: #2e7d32 !important;
}

.parchment-bulk-success-dialog__message {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
}
</style>
